import React from "react";

export const Page8English = () => {
  return (
    <div className="page-container">
      <p>
        We decided to build a new statue. We built the statue with wire mesh,
        cement, and other materials so that it would not be damaged for many
        years. They said we need eyes that will shower mercy. I was thinking
        about what to do, and I found out that an establishment in Karur makes
        luminous eyes that can be placed on statues. They sent me to choose the
        eyes that were requested for the facial structure. I bought two eyes for
        Rs. 5,000/-. It was then that I became more worried - if there is a
        mistake in the alignment of the eyes, there should be no upward gaze, no
        downward gaze, both eyes should be the same, otherwise it will turn out
        to be the opposite eye.
      </p>
      <p>
        Thinking about all this, one day I carefully fixed the eyes at night to
        see how they look in the light of the day and at night. When I thought
        about painting the statue to match the color, my friend. I thought of S.
        Thiyaku too. They accepted the task - they have painted it according to
        my wishes.
      </p>
      <p>
        He saw a dilapidated temple and went inside. The only place in the
        temple that did not leak was the roof above Shiva. He sat next to the
        Swami. The devotee could not sleep, so he planned how to renovate the
        temple. He would build a royal tower, build a wall, how to install
        sculptures for the Garbhagraha Vimana. He kept planning all night long
        how to make a good Kumbabhishekam by constructing a Thirukkulam to
        collect water for worshipping the Swami - a Nandavanam to collect
        flowers and offer prayers - after all these renovations were completed,
        he kept planning how to make the Kumbabhishekam.
      </p>
      <p>
        According to the law of Uttaman's life, by the order of the time, a
        black snake crawled to take his life that day. Seeing that, the cobra on
        Shiva's neck gave a warning to the black snake. The devotee here is
        planning to build a big temple for the Lord. Lord Shiva is happy with
        him and is supporting the roof of the temple with his head so that it
        does not fall. He warned that if you touch him, you will incur the wrath
        of God and go back. The black snake also turned back without touching
        him.
      </p>
      <p>
        When the sun rose and the rain stopped, he came out of the temple. The
        temple also collapsed. By the grace of God, his life was saved twice.
      </p>
    </div>
  );
};
